var _defs, _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelefon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.9 38.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ec6747;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.7,28.4c-.1-.2-.4-.4-.8-.6-.3-.1-.6-.3-1.1-.5-.9-.4-2.1-.9-3.3-1.4-.9-.4-2.2-.9-3.4-1.3-1.5-.5-2-.6-2.3-.4-.3,0-.5.2-1,.6-.3.2-.7.6-1.1,1.1-.7.6-1.5,1.5-2.4,2.5-.2.2-.6.3-.9.2-1.8-.9-4.1-2.1-6.5-3.9-3-2.4-5-5.1-6-8-.2-.6,0-1.3.4-1.8l3.9-3.7c.6-.6.7-1.5.3-2.2L10,.9C9.7.4,9.1,0,8.5,0c-1.2,0-3.3,0-4.8,1.1-.6.4-1.3,1.2-1.9,2.2-.7,1.2-1.3,2.6-1.6,4.1-.4,1.9-.4,3.9,0,5.9.5,2.4,1.4,4.9,2.9,7.5,3.4,5.8,8.6,10.1,12.4,12.7,4.3,2.9,8.2,4.7,9.6,5,.7.1,1.6.2,2.7.2,1.1,0,2.2,0,3.4-.3,2.8-.6,4.8-1.9,5.9-3.7.9-1.6,1.3-3,1.5-3.8,0-.5.3-1.8,0-2.4Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.9 38.7 27.9 38.7 27.9 38.7 27.9 38.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefon);
export default __webpack_public_path__ + "static/media/Telefon.b5100f51f79580933335414cec4883af.svg";
export { ForwardRef as ReactComponent };